export { default } from "./styled.mjs";